<div class="sales-dashboard">
    <form class="sales-dashboard__header flex-wrap justify-between" [formGroup]="salesTrackerForm">
        <app-multiselect-dropdown [multiselect]="false" [optionLoading]="salesTrackerLoading"
            [config]="userDropdownSettings" [options]="userOptions" [control]="salesTrackerForm.get('user')">
        </app-multiselect-dropdown>
        <div class="sales-dashboard__date flex-wrap justify-end" formGroupName="dateFilter">
            <div class="sales-dashboard__date-input">
                <label>Start Date</label>
                <input type="date" formControlName="startDate" />
            </div>
            <div class="sales-dashboard__date-input">
                <label>End Date</label>
                <input type="date" formControlName="endDate" />
            </div>
        </div>
    </form>
    <div class="sales-dashboard__leads flex-wrap">
        <div class="sales-dashboard__leads-item flex">
            <app-leads-card [isLoading]="salesTrackerLoading" [dateRange]="salesTrackerForm?.get('dateFilter')?.value"
                [totalLeads]="totalLeads"></app-leads-card>
        </div>
        <div class="sales-dashboard__leads-item flex">
            <app-leads-card [isLoading]="salesTrackerLoading" [dateRange]="salesTrackerForm?.get('dateFilter')?.value"
                [totalLeads]="totalConversions" [title]="'Total Conversions'"></app-leads-card>
        </div>
    </div>

    <div class="sales-dashboard__stats flex-wrap">
        <div class="sales-dashboard__stats-item flex" *ngFor="let data of stats">
            <app-sales-info-card class="flex" [isLoading]="salesTrackerLoading" [data]="data"></app-sales-info-card>
        </div>
    </div>

    <div class="sales-dashboard__graph flex-wrap">
        <div class="sales-dashboard__graph-item" *ngFor="let chartOptions of charts">
            <div class="sales-dashboard__graph-card">
                <h2>{{ chartOptions.title.text }}</h2>
                <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [labels]="chartOptions.labels"
                    [responsive]="chartOptions.responsive" [colors]="chartOptions.colors" [legend]="chartOptions.legend"
                    [stroke]="chartOptions.stroke">
                </apx-chart>
            </div>
        </div>
    </div>
</div>